// Google Analytics Configuration for Desi Pet Recipes

// Google Analytics Tracking ID - Connected to Desi Pet Recipes
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-PEY8L11DVY'; // Your GA4 Measurement ID

// Initialize Google Analytics
export const initGA = () => {
  // Add Google Analytics script to head
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  
  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID, {
    page_title: 'Desi Pet Recipes',
    custom_map: {
      'custom_parameter_1': 'pet_recipes'
    }
  });
};

// Track page views
export const trackPageView = (page_path, page_title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: page_path,
      page_title: page_title,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Business-specific tracking events
export const analytics = {
  // User registration tracking
  trackUserRegistration: (method) => {
    trackEvent('sign_up', 'user_engagement', 'registration', method);
  },

  // User login tracking
  trackUserLogin: (method) => {
    trackEvent('login', 'user_engagement', 'login_method', method);
  },

  // Premium subscription tracking
  trackPremiumPurchase: (plan, amount) => {
    trackEvent('purchase', 'monetization', 'premium_subscription', amount);
    // Enhanced ecommerce tracking
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'purchase', {
        transaction_id: `txn_${Date.now()}`,
        value: amount,
        currency: 'INR',
        items: [{
          item_id: plan,
          item_name: 'Premium Subscription',
          category: 'subscription',
          quantity: 1,
          price: amount
        }]
      });
    }
  },

  // Recipe creation tracking
  trackRecipeCreation: (petType, recipeType) => {
    trackEvent('create_recipe', 'user_engagement', `${petType}_${recipeType}`, 1);
  },

  // PDF export tracking
  trackPDFExport: (recipeId) => {
    trackEvent('export_pdf', 'user_engagement', 'recipe_pdf', recipeId);
  },

  // Special diet generation tracking
  trackSpecialDietGeneration: (dietType, petType) => {
    trackEvent('generate_special_diet', 'premium_features', `${dietType}_${petType}`, 1);
  },

  // Page engagement tracking
  trackPageEngagement: (pageName, timeSpent) => {
    trackEvent('page_engagement', 'user_behavior', pageName, timeSpent);
  }
};

export default analytics;